<template>
  <router-link draggable="false" :to="'/project/' + entry.id">
    <div class="project-entry">
      <div class="project-header">
        <div>
          <h3>{{ entry.number }}</h3>
          <h4>
            {{ entry.fullName }}
          </h4>
          <h4>({{entry.shortName}})</h4>
        </div>
        <div>{{ entry.status ? projectStatusDict[entry.status] : '-' }}</div>
      </div>
      <div v-if="passport" class="project-wrap">
        <div class="project-directions">
          <div class="project-moreInfo">
            <div>
              <h6>Сумма контрактов (план/факт)</h6>
              <p>
                {{
                  passport?.sum?.contractSum?.plan
                    ? passport.sum.contractSum.plan.toLocaleString('ru') + ' ₽'
                    : '&mdash;'
                }}
              </p>
              <p>
                {{
                  passport?.sum?.contractSum?.fact
                    ? passport.sum.contractSum.fact.toLocaleString('ru') + ' ₽'
                    : '&mdash;'
                }}
              </p>
            </div>
            <div>
              <h6>Сумма vi(план/факт)</h6>
              <p>
                {{
                  passport?.sum?.viContractSum?.plan
                    ? passport.sum.viContractSum.plan.toLocaleString('ru') +
                      ' ₽'
                    : '&mdash;'
                }}
              </p>
              <p>
                {{
                  passport?.sum?.viContractSum?.fact
                    ? passport.sum.viContractSum.fact.toLocaleString('ru') +
                      ' ₽'
                    : '&mdash;'
                }}
              </p>
            </div>
            <div>
              <h6>Сумма pri(план/факт)</h6>
              <p>
                {{
                  passport?.sum?.priProjectProfit?.plan
                    ? passport.sum.priProjectProfit.plan.toLocaleString('ru') +
                      ' ₽'
                    : '&mdash;'
                }}
              </p>
              <p>
                {{
                  passport?.sum?.priProjectProfit?.fact
                    ? passport.sum.priProjectProfit.fact.toLocaleString('ru') +
                      ' ₽'
                    : '&mdash;'
                }}
              </p>
            </div>
            <div>
              <h6>доля в pri (план/факт)</h6>
              <p>
                {{
                  passport?.sum?.profitShare?.plan
                    ? (
                      passport?.sum?.profitShare?.plan *
                        100
                      ).toFixed(2) + ' %'
                    : '&mdash;'
                }}
              </p>
              <p>
                {{
                  passport?.sum?.profitShare?.fact
                    ? (
                      passport?.sum?.profitShare?.fact *
                        100
                      ).toFixed(2) + ' %'
                    : '&mdash;'
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="project-info">
          <div>
            <h6>Руководитель</h6>
            <p v-if="entry.offerExpert">
              <router-link
                :to="'/employee/' + entry.offerExpert.id + '/info'"
                >{{ offerExpertName }}</router-link
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import { projectStatusDict, supMarketDict } from '@/modules/NSI';
import { dictToObject, getExpertShortName } from '@/modules/CommonUtils';

export default {
  name: 'ApplicationEntry',
  props: ['entry', 'offerExperts', 'passport'],
  data() {
    return {
      projectStatusDict: dictToObject(projectStatusDict),
      supMarketDict: dictToObject(supMarketDict),
    };
  },
  computed: {
    offerExpertName() {
      return getExpertShortName(
        this.offerExperts.find((e) => e.id === this.entry.offerExpert)
      );
    },
  },
  beforeMount() {
  },
};
</script>
